import { render, staticRenderFns } from "./sidebarPanels.vue?vue&type=template&id=1cdbb2a3&scoped=true"
import script from "./sidebarPanels.vue?vue&type=script&lang=js"
export * from "./sidebarPanels.vue?vue&type=script&lang=js"
import style0 from "./sidebarPanels.vue?vue&type=style&index=0&id=1cdbb2a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbb2a3",
  null
  
)

export default component.exports